import {createAction} from 'redux-actions'
import {isString, isNumber, isBoolean, isObject, mapItems, dict} from 'ldash'
import {isElement, isFragment} from 'react-is'

export const PPRINT_BUFFER = {data: null, expanded: null}

export const pprint = createAction(
  'PPRINT',
  (data, expanded = null) => {
    if (isString(data)) {
      return {string: data, __expanded__: expanded}
    } else if (isBoolean(data)) {
      return {bool: data, __expanded__: expanded}
    } else if (isNumber(data)) {
      return {number: data, __expanded__: expanded}
    } else {
      return {...data, __expanded__: expanded}
    }
  },
  () => ({silent: true})
)

export const set_pprint_buffer = (data, expanded = null) => {
  /* changes are collected by watchPPrintBuffer
   */
  if (isObject(data)) {
    // hashObj will be used, and that will crash on react elements
    data = dict(mapItems(data, (k, v) => [k, isElement(v) ? '<FILTERED_REACT>' : v]))
  }

  PPRINT_BUFFER.data = data
  PPRINT_BUFFER.expanded = expanded
}
